<template>
  <Datepicker
    v-model="internalValue"
    :range="isRange"
    :locale="russianLocale"
    :format="format"
    :placeholder="placeholder"
    select-text="Выбрать"
    cancel-text="Отменить"
    model-type="format" 
    input-class="w-100"
    :enable-time-picker="true"
    :teleport="true"
  />
</template>

<script>
import { defineComponent } from 'vue';
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

export default defineComponent({
  name: 'CustomDatepicker',
  components: { Datepicker },
  props: {
    modelValue: {
      type: [Date, Array],
      default: null,
    },
    isRange: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: 'dd-MM-yyyy HH:mm',
    },
    placeholder: {
      type: String,
      default: 'Выберите дату',
    },
  },
  data() {
    return {
      internalValue: this.modelValue,
      russianLocale: {
        id: 'ru',
        cancel: 'Отмена',
        select: 'Выбрать',
      },
    };
  },
  watch: {
    internalValue(newVal) {
      this.$emit('update:modelValue', newVal);
    },
    modelValue(newVal) {
      this.internalValue = newVal;
    },
  },
});
</script>

<style scoped>
.w-100 {
  width: 100%;
}
::v-deep(.dp__action_button) {
  color: var(--color-0) !important;
  background-color: var(--blue-0) !important;
}
::v-deep(.dp__action_cancel) {
	border: 0.1rem solid grey;
	color: var(--color-1) !important;
	background-color: transparent !important;
}

::v-deep(.dp__input) {
  border: 0.1rem solid var(--color-1);
  border-radius: 0.5rem;
}
::v-deep(.dp--clear-btn) {
  margin-right: 0.1rem;
}

::v-deep(.dp__input_icon) {
    width: 1rem !important;
    margin-left: 0.4rem !important;
    padding: 0.2rem !important;
}

::v-deep(.dp__range_start),
::v-deep(.dp__range_end) {
  background-color: var(--blue-0) !important;
  color: var(--color-0) !important;
}

::v-deep(.dp__range_between) {
  background-color: rgba(0, 123, 255, 0.2) !important;
  color: var(--color-1) !important;
}

::v-deep(.dp__active_date) {
	color: var(--color-0) !important;
	background-color: var(--blue-0) !important;
}
</style>






